module.exports = __webpack_public_path__ + "static/homepage-top-8fe86e6da09c0bdcbc183624fb74da98.svg";